import { useCallback, useMemo } from 'react';
import { useFormikSchemeContext } from './validationSchema.context';
import { useField } from 'formik';
import { reach } from 'yup';
var reachChunk = reach;
export default function (props) {
    var _a = useField(props), field = _a[0], meta = _a[1], helpers = _a[2];
    var error = meta.error;
    var name = field.name;
    var setError = helpers.setError;
    var validationSchema = useFormikSchemeContext();
    var validationSchemaChunk = useMemo(function () {
        try {
            // should throw if path is incorrect
            return reachChunk(validationSchema, name);
        }
        catch (err) {
            return null;
        }
    }, [validationSchema, name]);
    var validateSelf = useCallback(function (value) {
        if (validationSchemaChunk === null) {
            error && setError(undefined);
            return;
        }
        try {
            // should throw for invalid field value
            validationSchemaChunk.validateSync(value);
            error && setError(undefined);
        }
        catch (err) {
            setError(err.message);
        }
    }, [validationSchemaChunk, error]);
    return {
        validateSelf: validateSelf,
    };
}
